import { render, staticRenderFns } from "./SearchSuggestion.vue?vue&type=template&id=28d32a3a&scoped=true&"
import script from "./SearchSuggestion.vue?vue&type=script&lang=js&"
export * from "./SearchSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./SearchSuggestion.vue?vue&type=style&index=0&id=28d32a3a&prod&scoped=true&lang=css&"
import style1 from "./SearchSuggestion.vue?vue&type=style&index=1&id=28d32a3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d32a3a",
  null
  
)

export default component.exports